import i18n from "@/i18n/i18n"
export const type = {
    main: 1,
    sub: 2
}

export const userType = {
    notDefined: 0, 
    accountant: 1,
    viewer: 2,
    warehouseKeeper: 3,
    warehouseManger: 4
}

export const invoiceType = {
    buy: 1,
    sale: 2,
    buyRefund: 3,
    saleRefund: 4
}

export const invoicesTypes = [
    {
        id: 1,
        // name: i18n.t('invoice-type.buy')
        name: 'شراء'
    },
    {
        id: 2,
        // name: i18n.t('invoice-type.sale')
        name: 'بيع'
    },
    {
        id: 3,
        // name: i18n.t('invoice-type.buyRefund')
        name: 'مرتجع شراء'
    },
    {
        id: 4,
        // name: i18n.t('invoice-type.saleRefund')
        name: 'مرتجع بيع'
    }
];

export const bondType = {
    cash: 0,
    accounting: 1
};

export const accountConfigType = {
    sales: 1,
    purchases: 2,
    grantedDiscount: 3,
    vestedDiscount: 4,
    retainedEarnings: 5,
    endingInventory: 6,
    openingInventory: 7,
    salesRefund: 8,
    purchasesRefund: 9,
};

export const accountSuggestionType = {
    retainedEarnings: 1,
    openingInventory: 2,
    endingInventory: 3,
};

export const materialCategory = {
    commodity: 1,
    raw: 2,
    indirectRaw: 3,
    inProcess: 4,
    finished: 5,
};

export const transactionType = {
    in: 1,
    out: 2
};

export const InvoicesTransactionType = {
    receipt: 1,
    payment: 2,
    expensesBuy: 3,
    expensesSale: 4
}

export const userPermission = {
    accountant: 1,
    viewer: 2,
    warehouseKeeper: 3,
    warehouseManger: 4,
    advanceAccountant: 5
}

export const materialDeliveryStatus = [
    {
        id: 0,
        name: i18n.t('WarehouseInventoryPage.delivered')
    },
    {
        id: 1,
        name: i18n.t('WarehouseInventoryPage.being-received')
    }
    // {
    //     id: 2,
    //     name: i18n.t('WarehouseInventoryPage.being-deliver')
    // }
]

export const logTypes = [
    {
        logType: 0,
        name: i18n.t('AuditLog.accounts')
    },
    {
        logType: 1,
        name: i18n.t('AuditLog.accounting')
    },
    {
        logType: 2,
        name: i18n.t('AuditLog.currencies')
    },
    {
        logType: 3,
        name: i18n.t('AuditLog.financial-file')
    },
    {
        logType: 4,
        name: i18n.t('AuditLog.fund-flow')
    },
    {
        logType: 5,
        name: i18n.t('AuditLog.manufacturing')
    },
    {
        logType: 6,
        name: i18n.t('AuditLog.material-flow')
    },
    {
        logType: 7,
        name: i18n.t('AuditLog.material-warehouse')
    },
    {
        logType: 8,
        name: i18n.t('AuditLog.users')
    }
]

export const actionTypes = [
    {
        type: 0,
        name: i18n.t('AuditLog.fetch'),
    },
    {
        type: 1,
        name: i18n.t('AuditLog.create'),
    },
    {
        type: 2,
        name: i18n.t('AuditLog.update'),
    },
    {
        type: 3,
        name: i18n.t('AuditLog.delete'),
    }
]
export const actionType = {
    fetch: 0,
    create: 1,
    update: 2,
    delete: 3,
}
export const entryLogType = {
    finicalFiles: 'FinicialFiles',
    accounts: 'Accounts',
    contactInfos: 'ContactInfos',
    finicalFilesConfig: 'FinicialFiles_Config',
    currencies: 'Currencies',
    customStatements: 'CustomStatements',
    receiptBonds: 'ReceiptBonds',
    paymentBonds: 'PaymentBonds',
    cashEntries: 'CashEntries',
    accountingEntries: 'AccountingEntries',
    cashBonds: 'CashBonds',
    accountingBonds: 'AccountingBonds',
    receiptEntries: 'ReceiptEntries',
    paymentEntries: 'PaymentEntries',
    subInvoiceTypes: 'SubInvoiceTypes',
    buyInvoices: 'BuyInvocies',
    saleInvoices: 'SaleInvocies',
    buyRefundInvoices: 'BuyRefundInvocies',
    saleRefundInvoices: 'SaleRefundInvocies',
    buyMaterialEntries: 'BuyMaterialEntries',
    saleMaterialEntries: 'SaleMaterialEntries',
    buyRefundMaterialEntries: 'BuyRefundMaterialEntries',
    saleRefundMaterialEntries: 'SaleRefundMaterialEntries',
    roles: 'Roles',
    users: 'Users',
    transactionBonds: 'TransactionBonds',
    transactionEntries: 'TransactionEntries',
    manufacturingFiles: 'ManufacturingFiles',
    manufacturingFileEntries: 'ManufacturingFileEntries',
    manufacturingFileEntryRawMaterials: 'ManufacturingFileEntryRawMaterials',
    materialsJournals: 'MaterialsJournals',
    materialEntries: 'MaterialEntries',
    receiptInvoiceTransactions: 'ReceiptInvoiceTransactions',
    paymentInvoiceTransactions: 'PaymentInvoiceTransactions',
    expensesBuyInvoiceTransactions: 'ExpensesBuyInvoiceTransactions',
    expensesSaleInvoiceTransactions: 'ExpensesSaleInvoiceTransactions',
    materials: 'Materials',
    linkedMaterials: 'LinkedMaterials',
    unitSizes: 'UnitSizes',
    warehouses: 'Warehouses',
}